var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _polygon, _polygon2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _polygon3, _rect8, _path10, _path11, _path12, _path13, _path14, _polygon4, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirConditioner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.8,163c-11.2-4-20-8.5-26.2-13.5,6.2,5.1,15,9.7,26.2,13.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.3,163c-23.1,8-53.7,12.4-86.2,12.4,32.6,0,63.2-4.4,86.2-12.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M152,178.2c-6.4-9.8-7.4-22.1-2.6-32.8l17.7-39.7h.2c5.5-12.4,17.8-20.5,31.5-20.5h-.3c-13.5,0-26,8-31.5,20.5l-17.7,39.7c-4.7,10.7-3.7,23,2.6,32.8,6.4,9.9,17.3,15.7,28.9,15.7h.1c-11.8,0-22.5-5.9-28.9-15.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M146.3,179.2c0,0,0-.1-.1-.2v301.2c0,9.5,3.9,18.1,10.2,24.4-6.2-6.2-10-14.8-10-24.3V179.2Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.3,103c11.2,4,20,8.5,26.2,13.5-6.2-5.1-15-9.7-26.2-13.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.8,103c23.1-8,53.7-12.4,86.2-12.4-32.6,0-63.2,4.4-86.2,12.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.6,116.5c-6.4,5.2-9.6,10.8-9.6,16.5,0-5.7,3.2-11.2,9.6-16.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.5,149.5c6.4-5.2,9.6-10.8,9.6-16.5,0,5.7-3.2,11.2-9.6,16.5Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409,145.5c-5.6,4.5-14.1,8.9-24.5,12.5,10.5-3.6,18.9-7.9,24.5-12.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 375.5,
    y: 286.7,
    width: 39.7,
    height: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "232.3 329.2 232.4 329.2 232.4 286.8 276.1 286.8 276.1 286.7 232.3 286.7 232.3 329.2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "321.1 236.3 281.5 236.3 281.5 236.4 321.2 236.4 321.2 199.3 321.1 199.3 321.1 236.3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 321.1,
    y: 241.7,
    width: 0.1,
    height: 39.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 232.3,
    y: 334.4,
    width: 0.1,
    height: 39.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 232.3,
    y: 241.7,
    width: 0.1,
    height: 39.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 187.3,
    y: 236.3,
    width: 39.7,
    height: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 375.5,
    y: 374.1,
    width: 39.7,
    height: 0.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 326.5,
    y: 236.3,
    width: 43.8,
    height: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "276.1 236.3 232.4 236.3 232.4 199.3 232.3 199.3 232.3 236.4 276.1 236.4 276.1 236.3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 375.5,
    y: 236.3,
    width: 39.7,
    height: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M348.9,136.7c-2.3,2-5.9,3.7-10.6,5.4,4.5-1.5,8.2-3.4,10.6-5.4Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.8,147.5c-14.6,0-28.3-2-38.5-5.5,10.1,3.5,23.9,5.5,38.5,5.5Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M420.5,199.2v273h0v42.5s0,0,.1,0V199.2c12.9-.4,24.8-7.2,31.8-18,.4-.7.8-1.3,1.2-2v-.2c-.4.8-.9,1.4-1.3,2.2-7,10.9-18.9,17.6-31.8,18Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.8,129.4c2.3-2,5.9-3.7,10.6-5.4-4.5,1.5-8.2,3.4-10.6,5.4Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.8,118.5c14.6,0,28.3,2,38.5,5.5-10.1-3.5-23.9-5.5-38.5-5.5Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "247.5 140.7 247.5 140.7 247.5 140.7 247.5 140.7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.7,119c1.3-.5,2.8-.9,4.2-1.3-1.5.4-2.9.9-4.2,1.3Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.9,120.6c5.6-4.5,14.1-8.9,24.5-12.5-10.5,3.6-18.9,7.9-24.5,12.5Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.9,120.6c-5.2,4.2-7.7,8.4-7.7,12.4,0-4.1,2.6-8.2,7.7-12.4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.6,102.9c3.2-.8,6.6-1.4,10-2.1-3.4.6-6.8,1.3-10,2.1Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409,145.5c5.2-4.2,7.7-8.4,7.7-12.4,0,4.1-2.6,8.2-7.7,12.4Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.4,140.7c-2.9,2.3-6.9,4.4-12.2,6.3,5.3-1.8,9.3-3.8,12.2-6.3Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.5,125.3c2.9-2.3,6.9-4.4,12.2-6.3-5.3,1.8-9.3,3.8-12.2,6.3Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M458.8,158.4h0c-.1-5.2-1.2-10.2-3.4-15.1l-17.7-39.7c-6.4-14.3-20.7-23.7-36.3-23.7h-202.7c-15.7,0-29.9,9.2-36.3,23.7l-17.7,39.7c-2.2,4.8-3.3,10-3.4,15.1-.1.8-.2,1.5-.2,2.4v319.4c0,21.9,17.8,39.7,39.7,39.7h239.9c21.3-.8,38.4-18.3,38.4-39.7V160.8c0-.8,0-1.6-.2-2.4ZM181.9,514.6h-1.3c-9.5,0-18.1-3.8-24.3-10-6.3-6.2-10.2-14.9-10.2-24.4V179c0,0,0,.1.1.2.4.7.8,1.4,1.2,2,7.4,11.3,19.8,18,33.3,18h1.1v315.4ZM227,514.7h-39.7v-42.5h39.7v42.5ZM227,467h-39.7v-39.7h39.7v39.7ZM227,422h-39.7v-42.5h39.7v42.5ZM227,374.1h-39.7v-39.7h39.7v39.7ZM227,329.3h-39.7v-42.5h39.7v42.5ZM227,281.4h-39.7v-39.7h39.7v39.7ZM227,199.3v37h0c0,.1-39.7.1-39.7.1h0v-37.1h0c0-.1,39.7-.1,39.7-.1h0ZM232.4,241.7h43.7v39.7h-43.8v-39.7h.1ZM232.3,236.4v-37.1h43.8v37h0c0,.1-43.8.1-43.8.1ZM276.1,286.7h0v42.5h-43.8v-42.5h43.8ZM232.4,334.4h43.7v39.7h-43.8v-39.7h.1ZM276.2,514.7h-43.8v-42.5h43.8v42.5ZM276.2,467h-43.8v-39.7h43.8v39.7ZM276.2,422h-43.8v-42.5h43.8v42.5ZM321.1,514.7h-39.7v-42.5h39.7v42.5ZM321.1,467h-39.7v-39.7h39.7v39.7ZM321.1,422h-39.7v-42.5h39.7v42.5ZM321.1,374.1h-39.7v-39.7h39.7v39.7ZM321.1,329.3h-39.7v-42.5h39.7v42.5ZM321.2,281.4h-39.8v-39.7h39.8v39.7ZM321.2,236.4h-39.7c0-.1-.1-.1-.1-.1v-37.1h39.7c0,.1.1.1.1.1v37.1ZM370.2,514.7h-43.8v-42.5h43.8v42.5ZM370.2,467h-43.8v-39.7h43.8v39.7ZM370.2,422h-43.8v-42.5h43.8v42.5ZM370.2,374.1h-43.8v-39.7h43.8v39.7ZM370.2,329.3h-43.8v-42.5h43.8v42.5ZM370.2,281.4h-43.8v-39.7h43.8v39.7ZM370.2,236.3h0c0,.1-43.8.1-43.8.1h0v-37.1h43.8v37ZM415.2,514.7h-39.7v-42.5h39.7v42.5ZM415.2,467h-39.7v-39.7h39.7v39.7ZM415.2,422h-39.7v-42.5h39.7v42.5ZM415.2,374.1h0c0,.1-39.7.1-39.7.1h0v-39.7h0c0-.1,39.7-.1,39.7-.1v39.7ZM415.2,286.8v42.4h0c0,.1-39.7.1-39.7.1h0v-42.5h0c0-.1,39.7-.1,39.7-.1h0ZM415.2,281.4h-39.7v-39.7h39.7v39.7ZM415.2,236.3h0c0,.1-39.7.1-39.7.1h0v-37.1h0c0-.1,39.7-.1,39.7-.1v37.1ZM419,194h-238.2c-11.7,0-22.5-5.8-28.9-15.7-6.4-9.8-7.4-22.1-2.6-32.8l17.7-39.7c5.5-12.4,17.9-20.5,31.5-20.5h203.1c13.5,0,26,8,31.5,20.5l17.7,39.7c4.7,10.7,3.7,23-2.6,32.8-6.4,9.9-17.3,15.7-28.9,15.7h-.1ZM453.6,179.2v301.1c0,18.6-14.7,33.7-33,34.4,0,0,0,0-.1,0v-42.4h0V199.2c12.9-.4,24.8-7.1,31.8-18,.4-.8.9-1.4,1.3-2.2v.2Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M412.5,116.5c-6.2-5.1-15-9.6-26.2-13.5-23-8-53.7-12.4-86.2-12.4s-63.1,4.4-86.2,12.4c-11.2,3.8-20,8.5-26.2,13.5-6.4,5.3-9.6,10.8-9.6,16.5s3.2,11.3,9.6,16.5c6.2,5.1,15,9.6,26.2,13.5,23,8,53.7,12.4,86.2,12.4s63.1-4.4,86.2-12.4c11.2-3.8,20-8.5,26.2-13.5,6.4-5.3,9.6-10.8,9.6-16.5s-3.2-11.3-9.6-16.5ZM409,145.5c-5.6,4.6-14.1,8.9-24.5,12.5-22.4,7.8-52.5,12.1-84.5,12.1s-8,0-11.9-.2c-7.9-.3-15.5-.8-23-1.6-3.7-.4-7.4-.8-10.9-1.4-7.2-1-14-2.3-20.5-3.8-6.5-1.5-12.6-3.2-18.2-5.2-10.5-3.6-18.9-8-24.5-12.5-5.1-4.2-7.7-8.4-7.7-12.4s2.5-8.2,7.7-12.4c5.6-4.6,14.1-8.9,24.5-12.5,5.6-2,11.7-3.7,18.2-5.2,3.2-.8,6.6-1.4,10-2.1s6.9-1.2,10.5-1.7c3.6-.5,7.2-1,10.9-1.4,3.7-.4,7.5-.7,11.3-1,3.8-.3,7.7-.5,11.6-.6s7.9-.2,11.9-.2c32,0,62,4.3,84.5,12.1,10.5,3.6,18.9,8,24.5,12.5,5.1,4.2,7.7,8.4,7.7,12.4s-2.5,8.2-7.7,12.4Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M352.4,125.3c-2.9-2.4-6.9-4.5-12.2-6.3-1.3-.5-2.8-.9-4.2-1.3-1.5-.4-3-.8-4.5-1.2-1.5-.4-3.1-.7-4.8-1-4.9-.9-10.1-1.6-15.6-2-1.8-.1-3.7-.2-5.5-.3-1.9,0-3.7,0-5.6,0-5.7,0-11.3.3-16.6.9-4.4.5-8.7,1.1-12.6,2-2.4.5-4.7,1.1-6.9,1.7-1.5.4-2.9.9-4.2,1.3-5.3,1.9-9.3,4-12.2,6.3,0,0,0,0,0,0-3,2.4-4.5,5.1-4.5,7.7s1.5,5.3,4.5,7.7h0s0,0,0,0c2.9,2.4,6.9,4.5,12.2,6.3,1.3.5,2.8.9,4.2,1.3,2.2.6,4.5,1.2,6.9,1.7,4,.8,8.2,1.5,12.6,2,5.3.6,10.9.9,16.6.9s3.8,0,5.6,0c1.9,0,3.7-.2,5.5-.3,5.5-.4,10.7-1,15.6-2,1.6-.3,3.2-.6,4.8-1,1.5-.4,3-.7,4.5-1.2,1.5-.4,2.9-.9,4.2-1.3,5.3-1.9,9.3-4,12.2-6.3,3-2.4,4.5-5.1,4.5-7.7s-1.5-5.3-4.5-7.7ZM348.9,136.7c-2.3,2-6,3.8-10.6,5.4-10.2,3.5-23.9,5.5-38.5,5.5s-28.4-2-38.5-5.5c-4.6-1.6-8.2-3.4-10.6-5.4-1.7-1.3-2.5-2.6-2.5-3.6s.9-2.3,2.5-3.6c2.3-2,6-3.9,10.6-5.4,10.2-3.5,23.9-5.5,38.5-5.5s28.4,2,38.5,5.5c4.6,1.7,8.2,3.4,10.6,5.4,1.7,1.3,2.5,2.6,2.5,3.6s-.9,2.3-2.5,3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditioner);
export default __webpack_public_path__ + "static/media/air-conditioner.cced1168c3dc0a34d4a4aefcfb6b4d69.svg";
export { ForwardRef as ReactComponent };